<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
import { ref } from 'vue'

defineProps<{
  placeholder?: string
  hasError?: boolean,
  disabled?: boolean,
  label?: string,
  hintMessage?: string,
  errorMessage?: string
  containerClass?: string
  inputClass?: string
}>()

const model = defineModel<string>()

defineEmits<{
  (e: 'onFocus'): void
  (e: 'onBlur'): void
}>()

const input = ref<HTMLInputElement | null>(null)

function blurInput() {
  if (input.value) {
    input.value.blur()
  }
}
</script>
<template>
  <div class="flex flex-col gap-y-3">
    <slot
      v-if="$slots.label"
      name="label"
    />
    <p
      v-else-if="label"
      class="text-base font-semibold text-light-white/[70%]"
    >
      {{ label }}
    </p>
    <div
      :class="
        twMerge(
          'flex w-full items-center overflow-hidden px-4 py-[18px] rounded-xl bg-dark-top-layer text-white',
          hasError && 'border border-red-danger',
          disabled && 'pointer-events-none',
          containerClass
        )
      "
    >
      <input
        ref="input"
        v-model="model"
        :placeholder="placeholder"
        required
        autocomplete="off"
        :class="
          twMerge(
            'w-full flex-1 text-white/100 block border-0 text-base font-semibold placeholder:text-white/[38%] focus:border-transparent focus:outline-none focus:!ring-0 active:border-transparent active:outline-none active:!ring-0 bg-transparent px-2',
            inputClass
          )
        "
        @focus="$emit('onFocus')"
        @blur="$emit('onBlur')"
        @keydown.enter="blurInput"
      >
    </div>
    <p
      v-if="errorMessage && hasError"
      class="text-sm font-semibold text-red-danger"
    >
      {{ errorMessage }}
    </p>
    <p
      v-else-if="hintMessage"
      class="text-sm font-semibold text-white/60"
    >
      {{ hintMessage }}
    </p>
  </div>
</template>
